import { render, staticRenderFns } from "./product_sale_ribon.vue?vue&type=template&id=5afa931d&functionals=true&"
import script from "./product_sale_ribon.vue?vue&type=script&lang=js&"
export * from "./product_sale_ribon.vue?vue&type=script&lang=js&"
import style0 from "./product_sale_ribon.vue?vue&type=style&index=0&id=5afa931d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports